
import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function SecurityPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />

      <main className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          {/* パンくずリスト */}
          <nav className="mb-8">
            <ol className="flex items-center space-x-2 text-base">
              <li>
                <a href="/" className="text-gray-500 hover:text-pink-600 transition-colors cursor-pointer">
                  TOP
                </a>
              </li>
              <li className="text-gray-400">
                <i className="ri-arrow-right-s-line"></i>
              </li>
              <li className="text-gray-800 font-semibold">
                セキュリティガイド
              </li>
            </ol>
          </nav>

          {/* ページタイトル */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-pink-500 to-rose-500 rounded-2xl mb-6">
              <i className="ri-shield-check-line text-4xl text-white"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              セキュリティガイド
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              大切な資産を守るために、必ず知っておきたいこと
            </p>
          </div>

          {/* 重要な注意喚起 */}
          <div className="bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-red-500 rounded-lg p-8 mb-16">
            <div className="flex items-start">
              <div className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mr-4">
                <i className="ri-alarm-warning-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-red-700 mb-3">
                  まず最初に読んでください
                </h3>
                <p className="text-lg text-gray-800 leading-relaxed mb-3">
                  暗号通貨の世界では、<strong>あなた自身が銀行</strong>です。
                </p>
                <p className="text-lg text-gray-800 leading-relaxed">
                  誰もあなたの資産を守ってくれません。このページの内容を必ず理解してから、始めてください。
                </p>
              </div>
            </div>
          </div>

          {/* セクション1: ウォレット管理方法 */}
          <section className="mb-20">
            <div className="flex items-center mb-8">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl mr-4">
                <i className="ri-wallet-3-line text-2xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                ウォレット管理方法
              </h2>
            </div>

            <div className="space-y-6">
              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-pink-300 transition-colors">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-10 h-10 flex items-center justify-center bg-pink-100 text-pink-600 rounded-full mr-3 text-lg font-bold">
                    1
                  </span>
                  ウォレットとは？
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  ウォレットは、暗号通貨を保管する「デジタルのお財布」です。
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  銀行口座と違い、<strong>パスワードを忘れても誰も助けてくれません</strong>。すべて自己責任で管理する必要があります。
                </p>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-pink-300 transition-colors">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-10 h-10 flex items-center justify-center bg-pink-100 text-pink-600 rounded-full mr-3 text-lg font-bold">
                    2
                  </span>
                  おすすめのウォレット
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-pink-500 mr-3 mt-1"></i>
                    <div>
                      <p className="text-lg font-bold text-gray-900 mb-1">MetaMask（メタマスク）</p>
                      <p className="text-base text-gray-600">世界で最も使われているウォレット。初心者におすすめ。</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-pink-500 mr-3 mt-1"></i>
                    <div>
                      <p className="text-lg font-bold text-gray-900 mb-1">Ledger（レジャー）</p>
                      <p className="text-base text-gray-600">ハードウェアウォレット。最も安全な保管方法。</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-2xl text-pink-500 mr-3 mt-1"></i>
                    <div>
                      <p className="text-lg font-bold text-gray-900 mb-1">Trezor（トレザー）</p>
                      <p className="text-base text-gray-600">もう一つの人気ハードウェアウォレット。</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-pink-300 transition-colors">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="w-10 h-10 flex items-center justify-center bg-pink-100 text-pink-600 rounded-full mr-3 text-lg font-bold">
                    3
                  </span>
                  安全な管理のポイント
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-shield-check-line text-xl text-green-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700">パスワードは20文字以上の複雑なものを使う</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shield-check-line text-xl text-green-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700">二段階認証（2FA）を必ず設定する</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shield-check-line text-xl text-green-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700">公共のWi-Fiでは絶対にアクセスしない</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shield-check-line text-xl text-green-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700">定期的にウォレットのバックアップを取る</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* セクション2: シードフレーズとは */}
          <section className="mb-20">
            <div className="flex items-center mb-8">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl mr-4">
                <i className="ri-key-2-line text-2xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                シードフレーズとは
              </h2>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-orange-50 border-2 border-yellow-400 rounded-2xl p-8 mb-8">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-yellow-400 rounded-full flex-shrink-0 mr-4">
                  <i className="ri-error-warning-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-yellow-800 mb-3">
                    最も重要な情報です
                  </h3>
                  <p className="text-lg text-gray-800 leading-relaxed">
                    シードフレーズは、ウォレットを復元するための<strong>「マスターキー」</strong>です。これを失うと、二度と資産にアクセスできなくなります。
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  シードフレーズとは？
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  12個または24個の英単語の組み合わせです。
                </p>
                <div className="bg-gray-100 rounded-xl p-6 mb-4">
                  <p className="text-base text-gray-600 mb-2">例：</p>
                  <p className="text-lg font-mono text-gray-800">
                    apple banana cherry dragon elephant forest...
                  </p>
                </div>
                <p className="text-lg text-gray-700 leading-relaxed">
                  この単語の並びが、あなたのウォレットを復元する唯一の方法です。
                </p>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  正しい保管方法
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mr-4">
                      <i className="ri-check-line text-xl text-green-600"></i>
                    </div>
                    <div>
                      <p className="text-lg font-bold text-gray-900 mb-1">紙に書いて保管</p>
                      <p className="text-base text-gray-600">手書きで紙に書き、金庫や銀行の貸金庫に保管する</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mr-4">
                      <i className="ri-check-line text-xl text-green-600"></i>
                    </div>
                    <div>
                      <p className="text-lg font-bold text-gray-900 mb-1">金属プレートに刻印</p>
                      <p className="text-base text-gray-600">火事や水害でも失われない、専用の金属プレートを使う</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mr-4">
                      <i className="ri-check-line text-xl text-green-600"></i>
                    </div>
                    <div>
                      <p className="text-lg font-bold text-gray-900 mb-1">複数の場所に分散保管</p>
                      <p className="text-base text-gray-600">1箇所だけでなく、2〜3箇所に分けて保管する</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* セクション3: 絶対にやってはいけないこと */}
          <section className="mb-20">
            <div className="flex items-center mb-8">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-red-500 to-rose-600 rounded-xl mr-4">
                <i className="ri-forbid-2-line text-2xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                絶対にやってはいけないこと
              </h2>
            </div>

            <div className="space-y-6">
              <div className="bg-gradient-to-r from-red-50 to-pink-50 border-2 border-red-400 rounded-2xl p-8">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mr-4">
                    <i className="ri-close-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-red-700 mb-2">
                      シードフレーズをデジタルで保存
                    </h3>
                    <p className="text-lg text-gray-800 leading-relaxed">
                      スマホのメモ、パソコンのファイル、クラウドストレージ、これらは<strong>すべてハッキングのリスク</strong>があります。
                    </p>
                  </div>
                </div>
                <div className="bg-white rounded-xl p-6">
                  <p className="text-base text-gray-700 leading-relaxed">
                    <strong>❌ NG例：</strong><br />
                    ・スマホのメモアプリに保存<br />
                    ・パソコンのテキストファイルに保存<br />
                    ・Googleドライブ、Dropboxに保存<br />
                    ・スクリーンショットを撮る<br />
                    ・メールで自分に送る
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-red-50 to-pink-50 border-2 border-red-400 rounded-2xl p-8">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mr-4">
                    <i className="ri-close-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-red-700 mb-2">
                      シードフレーズを他人に教える
                    </h3>
                    <p className="text-lg text-gray-800 leading-relaxed">
                      どんな理由があっても、<strong>絶対に誰にも教えてはいけません</strong>。サポートを名乗る人も、すべて詐欺です。
                    </p>
                  </div>
                </div>
                <div className="bg-white rounded-xl p-6">
                  <p className="text-base text-gray-700 leading-relaxed">
                    <strong>❌ こんな言葉に騙されないで：</strong><br />
                    ・「確認のためシードフレーズを教えてください」<br />
                    ・「アカウント復旧のため入力してください」<br />
                    ・「セキュリティチェックのため必要です」<br />
                    <br />
                    <strong className="text-red-600">→ すべて詐欺です！</strong>
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-red-50 to-pink-50 border-2 border-red-400 rounded-2xl p-8">
                <div className="flex items-start mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mr-4">
                    <i className="ri-close-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-red-700 mb-2">
                      怪しいサイトでウォレットを接続
                    </h3>
                    <p className="text-lg text-gray-800 leading-relaxed">
                      知らないサイトにウォレットを接続すると、<strong>資産を全て盗まれる可能性</strong>があります。
                    </p>
                  </div>
                </div>
                <div className="bg-white rounded-xl p-6">
                  <p className="text-base text-gray-700 leading-relaxed">
                    <strong>✅ 接続前に必ず確認：</strong><br />
                    ・URLが正しいか（スペルミスがないか）<br />
                    ・HTTPSで始まっているか<br />
                    ・公式サイトかどうか<br />
                    ・コミュニティで話題になっているか
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-red-50 to-pink-50 border-2 border-red-400 rounded-2xl p-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-full flex-shrink-0 mr-4">
                    <i className="ri-close-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-red-700 mb-2">
                      「絶対儲かる」話に乗る
                    </h3>
                    <p className="text-lg text-gray-800 leading-relaxed">
                      「確実に儲かる」「元本保証」「今だけ特別」、<strong>これらは100%詐欺</strong>です。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* セクション4: 詐欺の見分け方 */}
          <section className="mb-20">
            <div className="flex items-center mb-8">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl mr-4">
                <i className="ri-spy-line text-2xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900">
                詐欺の見分け方
              </h2>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-300 rounded-2xl p-8 mb-8">
              <h3 className="text-2xl font-bold text-purple-800 mb-4">
                暗号通貨の世界は詐欺だらけです
              </h3>
              <p className="text-lg text-gray-800 leading-relaxed">
                残念ながら、暗号通貨の世界には詐欺師がたくさんいます。でも、パターンを知っていれば防げます。
              </p>
            </div>

            <div className="space-y-6">
              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <span className="w-10 h-10 flex items-center justify-center bg-red-100 text-red-600 rounded-full mr-3">
                    <i className="ri-alert-line text-xl"></i>
                  </span>
                  よくある詐欺のパターン
                </h3>
                <div className="space-y-6">
                  <div className="border-l-4 border-red-500 pl-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      1. 偽のサポート
                    </h4>
                    <p className="text-lg text-gray-700 leading-relaxed mb-3">
                      TwitterやDiscordで「サポートです」と名乗り、DMを送ってくる
                    </p>
                    <div className="bg-red-50 rounded-lg p-4">
                      <p className="text-base text-gray-800">
                        <strong>対策：</strong>公式サポートは絶対にDMを送ってきません。すべて無視してブロックしてください。
                      </p>
                    </div>
                  </div>

                  <div className="border-l-4 border-red-500 pl-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      2. エアドロップ詐欺
                    </h4>
                    <p className="text-lg text-gray-700 leading-relaxed mb-3">
                      「無料でトークンをあげます」と言って、ウォレット接続を求める
                    </p>
                    <div className="bg-red-50 rounded-lg p-4">
                      <p className="text-base text-gray-800">
                        <strong>対策：</strong>本物のエアドロップは、ウォレット接続不要です。怪しいサイトには絶対に接続しないでください。
                      </p>
                    </div>
                  </div>

                  <div className="border-l-4 border-red-500 pl-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      3. 偽サイト（フィッシング）
                    </h4>
                    <p className="text-lg text-gray-700 leading-relaxed mb-3">
                      本物そっくりの偽サイトを作り、ログイン情報を盗む
                    </p>
                    <div className="bg-red-50 rounded-lg p-4">
                      <p className="text-base text-gray-800">
                        <strong>対策：</strong>URLを必ず確認。ブックマークから開く習慣をつける。例：本物 metamask.io → 偽物 metamask-io.com
                      </p>
                    </div>
                  </div>

                  <div className="border-l-4 border-red-500 pl-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      4. ポンジスキーム
                    </h4>
                    <p className="text-lg text-gray-700 leading-relaxed mb-3">
                      「月利10%保証」など、ありえない高利回りを約束する
                    </p>
                    <div className="bg-red-50 rounded-lg p-4">
                      <p className="text-base text-gray-800">
                        <strong>対策：</strong>「確実に儲かる」は100%詐欺です。投資にリスクはつきもの。保証はありません。
                      </p>
                    </div>
                  </div>

                  <div className="border-l-4 border-red-500 pl-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      5. 偽の著名人
                    </h4>
                    <p className="text-lg text-gray-700 leading-relaxed mb-3">
                      有名人になりすまして、「送金すれば2倍にして返す」と言う
                    </p>
                    <div className="bg-red-50 rounded-lg p-4">
                      <p className="text-base text-gray-800">
                        <strong>対策：</strong>著名人が暗号通貨をプレゼントすることはありません。認証マーク（✓）があっても、偽アカウントの可能性があります。
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <span className="w-10 h-10 flex items-center justify-center bg-green-100 text-green-600 rounded-full mr-3">
                    <i className="ri-shield-check-line text-xl"></i>
                  </span>
                  詐欺を防ぐための心構え
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-2xl text-pink-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      <strong>急かされたら疑う</strong> — 「今すぐ」「期間限定」は詐欺の常套句です
                    </p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-2xl text-pink-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      <strong>うまい話は疑う</strong> — 簡単に儲かる方法は存在しません
                    </p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-2xl text-pink-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      <strong>わからないことは調べる</strong> — Googleで検索すれば、詐欺かどうかすぐわかります
                    </p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-2xl text-pink-500 mr-3 mt-1"></i>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      <strong>コミュニティで相談する</strong> — MAWARI FREAKで聞けば、誰かが教えてくれます
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* まとめ */}
          <section className="bg-gradient-to-br from-pink-500 to-rose-500 rounded-3xl p-10 text-white text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mx-auto mb-6">
              <i className="ri-heart-3-line text-3xl"></i>
            </div>
            <h2 className="text-3xl font-bold mb-4">
              安全第一で楽しみましょう
            </h2>
            <p className="text-xl leading-relaxed mb-8">
              セキュリティは面倒に感じるかもしれませんが、大切な資産を守るために必要なことです。わからないことがあれば、いつでもコミュニティで質問してください。
            </p>
            <a
              href="/community"
              className="inline-block px-10 py-4 bg-white text-pink-600 text-lg rounded-full font-bold hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap"
            >
              コミュニティに参加する
            </a>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
